

export const getFilterValue = (filterName, selectedValue) => {
  const hasArrayFilterValue = Array.isArray(selectedValue) && selectedValue.length > 0;
  const hasFilterValue = selectedValue || hasArrayFilterValue;

  return {
    [filterName]: hasFilterValue ? selectedValue : null
  };
};